export default "__VITE_ASSET__DizmeOwq__"